import { openModal } from '@members/modal';
import type { Source } from '@members/stacks';

const STACK_MODAL_NAME = 'stackFromNav';
export const openStackFromNav = (source: Source) => openModal(STACK_MODAL_NAME, source);
